<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">ارشيف الأحداث</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">ارشيف الأحداث</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <!--FILTER-->
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchEmail" class="form-control" placeholder="البريد الإلكتروني">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="modelSelect" v-model="searchModel" class="form-control">
                      <option :value="null">القسم</option>
                      <option v-for="(val, key) in modelNames" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="number" v-model="searchId" class="form-control" placeholder="ID الحدث">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchType">
                      <option :value="null">الحدث</option>
                      <option v-for="(val, key) in actionTypes" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header">
                <div class="card-header d-flex align-items-center">
                  <div class="card-title mb-0">ارشيف الأحداث</div>
                    <span v-if="countRows > 0"
                      class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                      عدد النتائج ( {{ countRows }} )</span>  
                  </div>
                </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الاسم</th>
                            <th>القسم</th>
                            <th>الحدث</th>
                            <th>تاريخ الإنشاء</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ (row.Admin)? row.Admin.name : 'غير معروف' }}</td>
                            <td>{{ modelNames[row.modelName] }}</td>
                            <td>{{ actionTypes[row.actionType] }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="`/histories/update/${row.id}`" class="btn btn-light btn-sm me-3"><i class="fa-regular fa-eye"></i></router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>


<script>
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'HistoriesList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      modelNames: {},
      actionTypes: {},
      searchName: this.$route.query.name || '',
      searchEmail: this.$route.query.email || '',
      searchModel: this.$route.query.model || null,
      searchType: this.$route.query.type || null,
      searchId: this.$route.query.sid ? parseInt(this.$route.query.sid) : null,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      showDateFilter: false,
      countRows: 0,
    }
  },
  methods: {
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchName.trim() != '')
        urlQuery.push(`name=${this.searchName.trim()}`);
      if(this.searchEmail.trim() != '')
        urlQuery.push(`email=${this.searchEmail.trim()}`);
      if(this.searchModel)
        urlQuery.push(`modelName=${this.searchModel}`);
      if(this.searchType)
        urlQuery.push(`actionType=${this.searchType}`);
      if (this.searchId)
        urlQuery.push(`rowId=${this.searchId}`);

      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchName !== null && this.searchName !== '' && this.searchName !== false ? { name: this.searchName } : {}),
        ...(this.searchEmail !== null && this.searchEmail !== '' && this.searchEmail !== false ? { email: this.searchEmail } : {}),
        ...(this.searchModel !== null && this.searchModel !== '' && this.searchModel !== false ? { model: this.searchModel } : {}),
        ...(this.searchType !== null && this.searchType !== '' && this.searchType !== false ? { type: this.searchType } : {}),
        ...(this.searchId !== null && this.searchId !== '' && this.searchId !== false ? { sid: this.searchId } : {}),
        ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/histories/list?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.rows;
        this.modelNames = data.modelNames;
        this.actionTypes = data.actionTypes;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
        this.initModelSelect();
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchName = '';
      this.searchEmail = '';
      this.searchModel = null;
      this.searchType = null;
      this.searchId = null;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },

    initModelSelect(){
      this.$nextTick(()=>{
        const el=this.$refs.modelSelect;
        if(!el) return;
        const $el=$(el);
        if($el.hasClass('select2-hidden-accessible')){
          $el.off('.model');
          $el.select2('destroy');
        }
        $el.select2({
          width:'100%',
          placeholder:'القسم',
        });
        $el.val(this.searchModel).trigger('change');
        $el.on('change.model',()=>{
          this.searchModel=$el.val()||null;
        });
      });
    },
  },
  mounted(){
    this.initModelSelect();
  },
  beforeUnmount(){
    const el=this.$refs.modelSelect;
    if(el){const $el=$(el);if($el.hasClass('select2-hidden-accessible')){$el.off('.model');$el.select2('destroy');}}
  },
  created(){
    this.getList();
  }
}
</script>